function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 392 392"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.21 126.43c3.7-7.31 7.67-14.44 12-21.32l3.36-5.1 3.52-5c1.23-1.63 2.41-3.29 3.65-4.91s2.53-3.21 3.82-4.79A185 185 0 0 1 83.4 67.43a208 208 0 0 1 19-15.66c3.35-2.41 6.74-4.78 10.25-7s7.11-4.28 10.75-6.32c7.29-4 14.73-8 22.53-11.49 3.9-1.72 7.88-3.3 12-4.64a104 104 0 0 1 12.44-3.23 62.4 62.4 0 0 1 12.78-1.39A25.9 25.9 0 0 1 196 21.44a6.55 6.55 0 0 1 2.05 9 6.7 6.7 0 0 1-1.64 1.78l-.41.29a22 22 0 0 1-5.78 3 30.4 30.4 0 0 1-5.67 1.62 38 38 0 0 1-5.69.71c-1 0-1.9.18-2.85.26l-2.85.24q-5.72.51-11.48 1.1c-3.84.4-7.71.82-11.58 1.4a112.3 112.3 0 0 0-22.94 5.61c-3.72 1.35-7.34 3-10.94 4.64s-7.14 3.51-10.6 5.51A151.6 151.6 0 0 0 68.56 87c-1.33 1.48-2.56 3-3.92 4.56s-2.51 3.15-3.75 4.73l-3.54 4.9c-1.13 1.66-2.23 3.35-3.33 5a127 127 0 0 0-10.93 21.49 1.58 1.58 0 1 1-3-1.15s.1-.06.12-.1",
    style: {
      fill: "#e0684b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h392v392H0z",
    style: {
      fill: "none"
    }
  })));
};
export default SvgSpinner;